import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from '../../../../../../Components/Loading';
import DataTable from '../../../../../Base/Components/DataTable/DataTable';
import ScrollContainer from '../../../../../Base/Components/ScrollContainer';
import OverlayLoading from '../../../../../../Components/OverlayLoading';
import {
	CareClaim,
	CareClaimDefaultColumns,
	CareClaimsTable,
} from '../../../../Consts/CareClaimDefaultColumns.const';

const WRAPPER_ID = 'careClaimWrapper';

interface Props {
	data: CareClaim[];
	isLoading: boolean;
	onRefresh: () => void;
	onLoadMore: () => void;
	hasMoreData: boolean;
	totalCount: number;
}

const ManagerInsuranceCompaniesCareClaimTable = ({
	data,
	isLoading,
	onRefresh,
	onLoadMore,
	hasMoreData,
	totalCount,
}: Props) => {
	const table: CareClaimsTable = { refresh: onRefresh };

	return (
		<>
			{isLoading && <OverlayLoading />}
			<ScrollContainer wrapperId={WRAPPER_ID}>
				<InfiniteScroll
					dataLength={data.length}
					refreshFunction={onRefresh}
					next={onLoadMore}
					hasMore={hasMoreData}
					loader={<Loading />}
					scrollableTarget={WRAPPER_ID}>
					<DataTable<CareClaim, CareClaimsTable>
						data={data}
						table={table}
						columns={CareClaimDefaultColumns}
						totalCount={totalCount}
					/>
				</InfiniteScroll>
			</ScrollContainer>
		</>
	);
};

export default ManagerInsuranceCompaniesCareClaimTable;
